import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import { Menu as AntdMenu } from 'antd'

import { useMenu, useUser } from 'data/hooks'

export const Menu = props => {

  const { slug } = props
  const { menu } = useMenu(slug)
  const { userId } = useUser()
  const [ current, setCurrent ] = useState()
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams()
  const gameId = params.gameId || playmotiv.game?.gameId
  // const elmenu = menu && menu.filter(option => option.key != 33 && option.key != 35)

  const getLink = menuOption => {

    const url = menuOption.link.split("/")
                          .map(key => {
                            switch(key) {
                              case ":menuId": return menuOption.id
                              case ":userId": return userId
                              case ":gameId": return gameId
                            }
                            return params[key] ? params[key] : key
                          })
                          .join("/")
    return url
  }

  const onClick = ({ item, key }) => {

    /*
    console.log('------------------------------------')
    console.log('************************************')
    console.log(key)
    console.log(props)
    console.log(item.props.data.type)
    */

    if(item.props.data.type == 'logout') {

      window.location.href = item.props.data.link

      return
    }

    if(props.type == 'gamemenu') {

      if(key == current && props.avoidreselect) {
        
        // console.log('avoidreselect') asdfasdf

        return
      }
      
      setCurrent(key) 
    }

    const url = getLink(item.props.data)

    if (url.indexOf('http') > -1) {

      document.location = url

    } else {

      navigate(url)
    }

    if (props.onClick) props.onClick(key)
  }

  useEffect(() => {

    if (!menu) return

    const option = menu
    .filter(option => {

      const link = option.data.link
      .split('/')
      .map(key => {
        switch(key) {
          case ":menuId": return option.id
          case ":userId": return userId
          case ":gameId": return gameId
        }
        return params[key] ? params[key] : key
      })
      .join('/')
      
      return location.pathname.startsWith(link)
    })
    .sort((a, b) => b.data.link.length - a.data.link.length)
    .shift()

    if (
      option
      &&
      props.type == 'gamemenu'
    ) setCurrent(option.key.toString())

  }, [menu])
  
  return <AntdMenu 
    { ...props }
    onClick={ onClick }
    selectedKeys={ [current] }
    items={
      menu ?
      menu
      .map(option => {

        if(option.data.image){

          option.icon = <img src={ option.data.image[0] } />
        }

        return option
      })
      :
      []
    }
  />
}